import DTSTAMP from './DTSTAMP'

/**
 * DUE property.
 *
 * @see https://tools.ietf.org/html/rfc5545#section-3.8.2.3
 */
export default class DUE extends DTSTAMP {
  static propName = 'DUE'
}



/** WEBPACK FOOTER **
 ** ./src/properties/DUE.js
 **/